<table style="height: 100% !important;">

  <tr>

    <td style="vertical-align:top;padding:20px;">

      <h5 translate>MAP.PHOTOGRAM.PHOTGRAMMETRY</h5>
      <p *ngIf="data.currentJob['hasRunPreview']">{{ 'MAP.PHOTOGRAM.PRICING' | translate }}
        <span class="fdm-count-inv fdm-text-large">{{estimatedPrice | qmap_round }}
          {{ 'ENTITY.CREDITS' | translate }}.</span>
      </p>
      <p *ngIf="!data.currentJob['hasRunPreview']">
        {{ 'MAP.PHOTOGRAM.ORTHO_PREVIEW' | translate }}</p>
      <p>{{ 'MAP.PHOTOGRAM.COST' | translate }}
        <span class="fdm-count-inv fdm-text-large">{{estimatedPrice | qmap_round }}
          {{ 'ENTITY.CREDITS' | translate }}.</span></p>
      <p>{{ 'MAP.PHOTOGRAM.BEGIN_PROCESS' | translate }}</p>

      <!-- <div style="margin-top:45px;">
            <mat-card *ngIf="estimatedPrice != -1" style="background-color:#eee;max-width:180px;">
              <h5 style="color:steelblue;padding:10px;">Cost</h5>
              <div class="mt-2" style="font-size: 14px;padding-bottom: 2px;">
              Cost is <span class="fdm-count-inv fdm-text-large">{{ 'PLAN.CURRENCY' | translate }} {{estimatedPrice | qmap_round }}</span>
            
              </div>
            </mat-card>
            <div class="mt-4" *ngIf="estimatedPrice == -1">
              <mat-spinner style="margin:0 auto;" strokeWidth="3"></mat-spinner>
            </div>
          </div> -->

    </td>

    <td *ngIf="data.currentJob['hasRunPreview']"
      style="width:50%;vertical-align:top;padding:20px;border-radius:5px;background-color:#eee;border:solid 1px #ddd;">

      <!-- <textarea style="height:200px;width:100%;font-size:10px;"> {{ this.data | json }} </textarea> -->
      <h5 style="text-align:center;width:100%;color:steelblue;padding:10px;">
        {{ 'MAP.PHOTOGRAM.PRODUCT_CHOICE' | translate }}</h5>

      <mat-checkbox class="ml-2" (change)="calculatePrice()" [checked]="true" disabled>
        <span style="font-size: 14px;padding-bottom: 2px;">
          {{ 'MAP.PHOTOGRAM.PRODUCT_INCLUSION' | translate }}
        </span>
      </mat-checkbox>
      <br>
      <mat-checkbox class="ml-2" (change)="calculatePrice()" [(ngModel)]="data.currentJob['doTMS']">
        <span style="font-size: 14px;padding-bottom: 2px;">
          {{ 'MAP.PHOTOGRAM.ORTHO_TRUE' | translate }}
        </span>
      </mat-checkbox>
      <br>
      <mat-checkbox class="ml-2" (change)="calculatePrice()" [(ngModel)]="data.currentJob['doLAZ']">
        <span style="font-size: 14px;padding-bottom: 2px;">
          {{ 'MAP.PHOTOGRAM.POINT_CLOUDS' | translate }}
        </span>
      </mat-checkbox>
      <br>
      <div *ngIf="data.currentJob['doLAZ']" style="margin-left:25px;">
        <mat-checkbox class="ml-2" [(ngModel)]="data.currentJob['bareEarth']">
          <span style="font-size: 12px;white-space:normal!important;line-height:14px!important;display:block;">
            {{ 'MAP.PHOTOGRAM.BARE_EARTH' | translate }}
          </span>
        </mat-checkbox>
      </div>
      <mat-checkbox (change)="calculatePrice()" class="ml-2" [(ngModel)]="data.currentJob['doDEM']">
        <span style="font-size: 14px;padding-bottom: 2px;">
          {{ 'MAP.PHOTOGRAM.DTM' | translate }}
        </span>
      </mat-checkbox>
      <br>
      <mat-checkbox (change)="calculatePrice()" class="ml-2" [(ngModel)]="data.currentJob['doTile']">
          <span style="font-size: 14px;padding-bottom: 2px;">
          Textured Mesh Model
          </span>
        </mat-checkbox>

      <!-- <div style="margin-top:45px;">
          <mat-card>
            <h5 style="text-align:center;width:100%;color:steelblue;padding:10px;">Price calculator</h5>
            <div class="mt-2" style="font-size: 14px;padding-bottom: 2px;">
            {{mapService.scene._photo_count}} images<br>
            {{data.gigaPixels}} GigaPixels<br>
            Cost is <span class="fdm-count-inv fdm-text-large">{{ 'PLAN.CURRENCY' | translate }}  {{estimatedPrice}}</span>
          
            </div>
          </mat-card>
          </div> -->

    </td>

  </tr>

</table>

<div class="mt-2">
  <!-- [disabled]="!data.currentJob['doTMS'] && !data.currentJob['doLAZ'] && !data.currentJob['doDEM'] && !data.currentJob['doTile']"-->
  <button mat-raised-button
    [disabled]="data.isFullProcessing && !data.currentJob['doTMS'] && !data.currentJob['doLAZ'] && !data.currentJob['doDEM'] && !data.currentJob['doTile']"
    class="mr-2" color="primary" (click)="agree()">
    {{ 'MAP.PHOTOGRAM.START_PROCESS' | translate }}
  </button>
  <button mat-raised-button color="default" (click)="dialogRef.close(false)">{{ 'GENERIC.CANCEL' | translate }}</button>
</div>